import React from "react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import CompareModalTableBody from "properties/compare/modal/compare-modal-table-body";
import { COMMON_RESOURCE } from "_common/resources/BaseResourceStore";
import { CompareProps } from "properties/propertyCard/components/favorite/compare-provider";
import { CompareModalTablePropertyHeader } from "properties/compare/modal/compare-modal-table-property-header";
import { CompareModalTableUnitHeader } from "properties/compare/modal/compare-modal-table-unit-header";

interface Props {
    selectedItems: CompareProps[];
}

export default function CompareModalTable({ selectedItems }: Props) {
    return (
        <div className="overflow-x-auto mt-10">
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className="sticky left-0 bg-gray-100 z-10 min-w-[135px] md:min-w-[150px]"></TableCell>
                        {selectedItems.map((item) => {
                            if (item.resource === COMMON_RESOURCE.PROPERTIES) {
                                return <CompareModalTablePropertyHeader key={item.itemId} item={item} />;
                            }

                            if (item.resource === COMMON_RESOURCE.UNIT) {
                                return <CompareModalTableUnitHeader key={item.itemId} item={item} />;
                            }
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <CompareModalTableBody selectedItems={selectedItems} />
                </TableBody>
            </Table>
        </div>
    );
}
